export default "__VITE_ASSET__$Gv9pPO4__"